import { IDefineCommand } from 'core-ts-types';

angular.module('lib').service('stopImpersonationCommand', ($http: ng.IHttpService, defineCommand: IDefineCommand) => {
  return defineCommand('stopImpersonationCommand', (deferred) => {
    $http
      .delete('/core/impersonation/')
      .then((response) => {
        deferred.resolve(response.data);
      })
      .catch((response) => {
        return deferred.reject(response.data);
      });
  });
});



// WEBPACK FOOTER //
// ./app/lib/header/commands/stop_impersonation_command.ts